import QueryString from "qs";
import { useContext } from "react";
import { useHistory } from "react-router";

import { usePortalRoutes } from "../../../../hooks/usePortalRoutes";
import { RouteFeature } from "../../../../routes/feature";
import { RouteLayout } from "../../../../routes/layout";
import ReportWidgetCard from "../../../ReportWidgetCard/ReportWidgetCard";
import { ReportContext } from "../../ReportContext";

export const ReportLeadsOpenedWidget = ({
  parentRoute,
}: {
  parentRoute: string;
}) => {
  const { createClubLink } = usePortalRoutes();
  const data = useContext(ReportContext);
  const history = useHistory();

  return (
    <ReportWidgetCard
      title="Open Leads"
      value={data.leads?.opened?.total.toString() || "0"}
      isLoading={data.isLoading}
      explanation="Sum of all leads that were created in the selected period that are not in a Deal Won or Deal Lost status."
      variation={data.leads?.opened?.variation}
      onClick={() => {
        history.push({
          pathname: createClubLink(RouteLayout.Staff, RouteFeature.OpenedLeads),
          search: QueryString.stringify({
            backRoute: parentRoute,
          }),
        });
      }}
    />
  );
};
